import AuthBasePageWrapper from '../../AuthBasePageWrapper'
import LoginPanel from './LoginPanel'


const LoginPage = ({identityProviderRedirectUrl}:{identityProviderRedirectUrl?: string}) => {

  return (
    <AuthBasePageWrapper>
      <LoginPanel identityProviderRedirectUrl={identityProviderRedirectUrl}/>
    </AuthBasePageWrapper>
  )
}


export default LoginPage
